"use client";

import { LanguageParams } from "@/lib/types/PageProps";
import { OverlayViewF, OVERLAY_MOUSE_TARGET } from "@react-google-maps/api";
import Room, { RoomProps } from "../Room";
import { faClose } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useClickAway } from "@uidotdev/usehooks";
import { RefObject, useEffect, useState } from "react";
import { breakpointIsLessThan } from "@/lib/utils/tailwind";
import { useTailwindBreakpoint } from "@/lib/hooks/useTailwindBreakpoint";
import { SCREEN_SIZE } from "@/lib/constants/tailwind";
import MobileMapRoom from "../Room/MobileMapRoom";
import { Transition } from "@headlessui/react";


type Props = {
    listing: RoomProps;
    onClose: () => void;
    container: RefObject<HTMLDivElement>;
} & LanguageParams;

const MarkerDetails = ({ listing, onClose, container }: Props) => {
    const [, currentBreakpoint] = useTailwindBreakpoint();
    const TABLET_BREAKPOINT: SCREEN_SIZE = "md";
    const [isMobile, setIsMobile] = useState(breakpointIsLessThan(currentBreakpoint, TABLET_BREAKPOINT));

    useEffect(() => {
        setIsMobile(breakpointIsLessThan(currentBreakpoint, TABLET_BREAKPOINT));
    }, [currentBreakpoint]);

    const refMakerDetails = useClickAway(event => {
        // only close opened room if we click inside container - map
        if (event.target && !container.current?.contains(event.target as Node)) {
            return;
        }
        onClose();
    });

    return (
        <Transition appear={true} show={true} enter="transition-opacity duration-500" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity duration-500" leaveFrom="opacity-100" leaveTo="opacity-0">
            {isMobile ?
                <div className="absolute bottom-16 w-full h-52 p-4 z-20" ref={refMakerDetails as React.LegacyRef<HTMLDivElement>}>
                    <MobileMapRoom {...listing} className="h-full w-full" />
                </div>
                :
                <OverlayViewF position={{ lat: listing.location.lat, lng: listing.location.lng }} zIndex={11} mapPaneName={OVERLAY_MOUSE_TARGET} getPixelPositionOffset={(offsetWidth, offsetHeigt) => ({ x: -(offsetWidth / 2), y: -(offsetHeigt / 2) })}>
                    <div ref={refMakerDetails as React.LegacyRef<HTMLDivElement>} className="w-80 hidden md:block" onDrag={e => e.stopPropagation()} onClick={e => { e.stopPropagation(); e.preventDefault(); /* not sure this works, found no other alternative to preventing events being propagated to map */ }}>
                        <div className="absolute top-4 right-4 z-20 text-white hover:text-black cursor-pointer" onClick={onClose}>
                            <FontAwesomeIcon icon={faClose} size="lg" />
                        </div>
                        <Room {...listing} className="h-full w-full" />
                    </div>
                </OverlayViewF>
            }
        </Transition>
    );
};

export default MarkerDetails;
